import Config from "../../../resources/config.js";

async function handleResponse(response) {
  if (response.status === 200) {
    let responseObject = await response.json();
    return responseObject.responseData;
  } else if (response.status === 400) {
    throw await response.json();
  } else {
    throw response;
  }
}

export default {

  async getAdminData() {
    let url = `${Config.apiHost}/admin/dashboard`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getAssistants(status, keywords) {
    let url = `${Config.apiHost}/admin/get-assistants?n=100`;
    if (status) {
      url += '&status=' + status
    }
    if (keywords && keywords.trim().length > 0) {
      url += '&keywords=' + keywords.trim();
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getClients(status, keywords) {
    let url = `${Config.apiHost}/admin/get-clients?n=100`;
    if (status) {
      url += '&status=' + status
    }
    if (keywords && keywords.trim().length > 0) {
      url += '&keywords=' + keywords.trim();
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getProjects(status) {
    let url = `${Config.apiHost}/admin/get-projects?n=100`;
    if (status) {
      url += '&status=' + status
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getProposals(status) {
    let url = `${Config.apiHost}/admin/get-proposals?n=100`;
    if (status) {
      url += '&status=' + status
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getVideos(status) {
    let url = `${Config.apiHost}/admin/get-videos?n=100`;
    if (status) {
      url += '&status=' + status
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getCourses(status) {
    let url = `${Config.apiHost}/admin/get-courses?n=100`;
    if (status) {
      url += '&status=' + status
    }
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getAssistant(assistantId) {
    let url = `${Config.apiHost}/admin/get-assistant/${assistantId}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getClient(clientId) {
    let url = `${Config.apiHost}/admin/get-client/${clientId}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getProject(projectId) {
    let url = `${Config.apiHost}/admin/get-project/${projectId}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getProposal(assistantId, projectId) {
    let url = `${Config.apiHost}/admin/get-proposal/${assistantId}/${projectId}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getVideo(videoId, n) {
    let url = `${Config.apiHost}/admin/get-video/${videoId}?n=${n}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getClass(courseId, classId, n) {
    let url = `${Config.apiHost}/admin/get-course-class/${courseId}/${classId}?n=${n}`;
    let response = await fetch(url, { credentials: "include" });
    return await handleResponse(response);
  },

  async getClassComments(courseId, classId, lastComment, resultCount) {
    let url = `${Config.apiHost}/admin/get-class-comments/${courseId}/${classId}?n=${resultCount}`;

    if (lastComment) {
      url += '&lv=' + lastComment.registration_timestamp + "&lp=" + lastComment.position;
    }

    let response = await fetch(url, {
      method: "GET",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async getClassChildrenComments(classId, commentId) {
    let url = `${Config.apiHost}/admin/get-class-children-comments/${classId}/${commentId}`;

    let response = await fetch(url, {
      method: "GET",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async replyClassComment(classId, commentId, commentDetails) {
    let url = `${Config.apiHost}/admin/reply-class-comment/${classId}/${commentId}`;
    let formData = new FormData();

    if (commentDetails.comment) {
      formData.append('comment', commentDetails.comment);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async getVideoComments(videoId, lastComment, resultCount) {
    let url = `${Config.apiHost}/admin/get-video-comments/${videoId}?n=${resultCount}`;

    if (lastComment) {
      url += '&lv=' + lastComment.registration_timestamp + "&lp=" + lastComment.position;
    }

    let response = await fetch(url, {
      method: "GET",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async getVideoChildrenComments(commentId) {
    let url = `${Config.apiHost}/admin/get-video-children-comments/${commentId}`;

    let response = await fetch(url, {
      method: "GET",
      credentials: "include"
    });

    return await handleResponse(response);

  },

  async replyVideoComment(commentId, commentDetails) {
    let url = `${Config.apiHost}/admin/reply-video-comment/${commentId}`;
    let formData = new FormData();

    if (commentDetails.comment) {
      formData.append('comment', commentDetails.comment);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateVideoComment(commentId, commentDetails) {
    let url = `${Config.apiHost}/admin/update-video-comment/${commentId}`;
    let formData = new FormData();

    if (commentDetails.comment) {
      formData.append('comment', commentDetails.comment);
    }

    if (commentDetails.status) {
      formData.append('status', commentDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateClassComment(classId, commentId, commentDetails) {
    let url = `${Config.apiHost}/admin/update-class-comment/${classId}/${commentId}`;
    let formData = new FormData();

    if (commentDetails.comment) {
      formData.append('comment', commentDetails.comment);
    }

    if (commentDetails.status) {
      formData.append('status', commentDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateAssistant(assistantId, assistantDetails) {
    let url = `${Config.apiHost}/admin/update-assistant/${assistantId}`;
    let formData = new FormData();
    let pictureFile = assistantDetails.picture;
    let removePicture = assistantDetails.removePicture;

    delete assistantDetails['picture'];
    delete assistantDetails['removePicture'];

    if (assistantDetails.name) {
      formData.append('name', assistantDetails.name);
    }

    if (assistantDetails.phone) {
      formData.append('phone', assistantDetails.phone);
    }

    if (assistantDetails.title) {
      formData.append('title', assistantDetails.title);
    }

    if (assistantDetails.description) {
      formData.append('description', assistantDetails.description);
    }

    if (assistantDetails.expertise_areas) {
      formData.append('expertise_areas', JSON.stringify(assistantDetails.expertise_areas));
    }

    if (assistantDetails.certifications) {
      formData.append('certifications', JSON.stringify(assistantDetails.certifications));
    }

    if (assistantDetails.status) {
      formData.append('status', assistantDetails.status);
    }

    if (pictureFile) {
      formData.append('picture_file', pictureFile);
    } else if (removePicture) {
      formData.append('remove_picture', true);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async addSubscription(assistantId, subscriptionInfo) {
    let url = `${Config.apiHost}/admin/add-subscription-order/${assistantId}/${subscriptionInfo.orderRef}`;
    let formData = new FormData();
    formData.append("details", subscriptionInfo.details);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async cancelSubscription(assistantId, subscriptionId) {
    let url = `${Config.apiHost}/admin/cancel-subscription/${assistantId}/${subscriptionId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async syncSubscription(assistantId) {
    let url = `${Config.apiHost}/admin/sync-subscription/${assistantId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  syncStripe() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${Config.apiHost}/admin/sync-stripe-subscriptions`;;
    form.target = '_blank'; // Opens in a new tab
    form.style.display = 'none';

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },

  async addCourse(courseInfo) {
    let url = `${Config.apiHost}/admin/add-course/${courseInfo.id}`;
    let formData = new FormData();
    formData.append("title", courseInfo.title);
    formData.append("plan", courseInfo.plan);
    formData.append("path", courseInfo.path);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },
  async addAssistantCourse(assistantId, courseInfo) {
    let url = `${Config.apiHost}/admin/add-course-order/${assistantId}/${courseInfo.course_id}`;
    let formData = new FormData();
    formData.append("details", courseInfo.details);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },


  async deleteCourse(courseId) {
    let url = `${Config.apiHost}/admin/delete-course/${courseId}`;

    let response = await fetch(url, {
      method: "DELETE",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async cancelOrder(assistantId, orderId) {
    let url = `${Config.apiHost}/admin/cancel-order/${assistantId}/${orderId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async syncAssistantOrders(assistantId) {
    let url = `${Config.apiHost}/admin/sync-orders/${assistantId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  syncOrders() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${Config.apiHost}/admin/sync-orders`;;
    form.target = '_blank'; // Opens in a new tab
    form.style.display = 'none';

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },

  resetOffers() {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = `${Config.apiHost}/admin/reset-offers`;;
    form.target = '_blank'; // Opens in a new tab
    form.style.display = 'none';

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },

  async setBillingDetails(assistantId, billingDetails) {
    let url = `${Config.apiHost}/admin/set-billing-details/${assistantId}`;
    let formData = new FormData();

    formData.append("billing_details", JSON.stringify(billingDetails));

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateClient(clientId, clientDetails) {
    let url = `${Config.apiHost}/admin/update-client/${clientId}`;
    let formData = new FormData();
    let pictureFile = clientDetails.picture;
    let removePicture = clientDetails.removePicture;

    delete clientDetails['picture'];
    delete clientDetails['removePicture'];

    if (clientDetails.name) {
      formData.append('name', clientDetails.name);
    }

    if (clientDetails.contact_info) {
      formData.append('contact_info', JSON.stringify(clientDetails.contact_info));
    }

    if (clientDetails.status) {
      formData.append('status', clientDetails.status);
    }

    if (pictureFile) {
      formData.append('picture_file', pictureFile);
    } else if (removePicture) {
      formData.append('remove_picture', true);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateProject(projectId, projectDetails) {
    let url = `${Config.apiHost}/admin/update-project/${projectId}`;
    let formData = new FormData();

    if (projectDetails.title) {
      formData.append('title', projectDetails.title);
    }

    if (projectDetails.description) {
      formData.append('description', projectDetails.description);
    }

    if (projectDetails.exclusive !== undefined) {
      formData.append('exclusive', projectDetails.exclusive);
    }

    if (projectDetails.status) {
      formData.append('status', projectDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateProposal(assistantId, projectId, proposalDetails) {
    let url = `${Config.apiHost}/admin/update-proposal/${assistantId}/${projectId}`;
    let formData = new FormData();

    if (proposalDetails.proposal) {
      formData.append('proposal', proposalDetails.proposal);
    }

    if (proposalDetails.status) {
      formData.append('status', proposalDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async finishProposal(assistantId, projectId) {
    let url = `${Config.apiHost}/admin/finish-proposal/${assistantId}/${projectId}`;
    let response = await fetch(url, {
      method: "POST",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async addVideo(videoDetails) {
    let url = `${Config.apiHost}/admin/add-video`;
    let formData = new FormData();

    if (videoDetails.type) {
      formData.append('type', videoDetails.type);
    }

    if (videoDetails.title) {
      formData.append('title', videoDetails.title);
    }

    if (videoDetails.path) {
      formData.append('path', videoDetails.path);
    }

    if (videoDetails.course_id) {
      formData.append('course_id', videoDetails.course_id);
    }

    if (videoDetails.video_file) {
      formData.append('video_file', videoDetails.video_file);
    }

    if (videoDetails.description) {
      formData.append('description', videoDetails.description);
    }

    if (videoDetails.links) {
      formData.append('links', JSON.stringify(videoDetails.links));
    }

    if (videoDetails.release_threshold) {
      formData.append('release_threshold', videoDetails.release_threshold);
    }

    if (videoDetails.meetup_link) {
      formData.append('meetup_link', videoDetails.meetup_link);
    }

    if (videoDetails.status) {
      formData.append('status', videoDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateVideo(videoId, videoDetails) {
    let url = `${Config.apiHost}/admin/update-video/${videoId}`;
    let formData = new FormData();

    if (videoDetails.type) {
      formData.append('type', videoDetails.type);
    }

    if (videoDetails.title) {
      formData.append('title', videoDetails.title);
    }

    if (videoDetails.course_id) {
      formData.append('course_id', videoDetails.course_id);
    }

    if (videoDetails.path) {
      formData.append('path', videoDetails.path);
    }

    if (videoDetails.video_file) {
      formData.append('video_file', videoDetails.video_file);
    }

    if (videoDetails.description) {
      formData.append('description', videoDetails.description);
    }

    if (videoDetails.links) {
      formData.append('links', JSON.stringify(videoDetails.links));
    }

    if (videoDetails.release_threshold) {
      formData.append('release_threshold', videoDetails.release_threshold);
    }

    if (videoDetails.meetup_link) {
      formData.append('meetup_link', videoDetails.meetup_link);
    }

    if (videoDetails.status) {
      formData.append('status', videoDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async deleteVideo(videoId) {
    let url = `${Config.apiHost}/admin/delete-video/${videoId}`;

    let response = await fetch(url, {
      method: "DELETE",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateCourse(courseId, courseDetails) {
    let url = `${Config.apiHost}/admin/update-course/${courseId}`;
    let formData = new FormData();

    if (courseDetails.title) {
      formData.append('title', courseDetails.title);
    }

    if (courseDetails.path) {
      formData.append('path', courseDetails.path);
    }

    if (courseDetails.plan) {
      formData.append('plan', courseDetails.plan);
    }

    if (courseDetails.status) {
      formData.append('status', courseDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateModule(moduleId, moduleDetails) {
    let url = `${Config.apiHost}/admin/update-module/${moduleId}`;
    let formData = new FormData();

    if (moduleDetails.title) {
      formData.append('title', moduleDetails.title);
    }

    if (moduleDetails.number) {
      formData.append('number', moduleDetails.number);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async addClass(courseId, classDetails) {
    let url = `${Config.apiHost}/admin/add-class/${courseId}`;
    let formData = new FormData();

    if (classDetails.title) {
      formData.append('title', classDetails.title);
    }

    if (classDetails.path) {
      formData.append('path', classDetails.path);
    }

    if (classDetails.newModuleTitle) {
      formData.append('new_module_title', classDetails.newModuleTitle);
    } else {
      formData.append('module_id', classDetails.module_id);
    }

    formData.append('release_threshold', classDetails.release_threshold);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateClass(courseId, classId, classDetails) {
    let url = `${Config.apiHost}/admin/update-class/${courseId}/${classId}`;
    let formData = new FormData();

    if (classDetails.title) {
      formData.append('title', classDetails.title);
    }

    if (classDetails.number) {
      formData.append('number', classDetails.number);
    }

    if (classDetails.path) {
      formData.append('path', classDetails.path);
    }

    if (classDetails.description) {
      formData.append('description', classDetails.description);
    }

    if (classDetails.links) {
      formData.append('links', JSON.stringify(classDetails.links));
    }

    if (classDetails.release_threshold) {
      formData.append('release_threshold', classDetails.release_threshold);
    }

    if (classDetails.status) {
      formData.append('status', classDetails.status);
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async deleteClass(courseId, classId) {
    let url = `${Config.apiHost}/admin/delete-class/${courseId}/${classId}`;

    let response = await fetch(url, {
      method: "DELETE",
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async addReview(assistantId, projectId, reviewDetails) {
    let url = `${Config.apiHost}/admin/add-review/${projectId}/${assistantId}`;
    let formData = new FormData();

    formData.append('assistant_rating', reviewDetails.assistant_rating);
    formData.append('assistant_comment', reviewDetails.assistant_comment);
    formData.append('assistant_platform_rating', reviewDetails.assistant_platform_rating);
    formData.append('assistant_platform_comment', reviewDetails.assistant_platform_comment);

    formData.append('client_rating', reviewDetails.client_rating);
    formData.append('client_comment', reviewDetails.client_comment);
    formData.append('client_platform_rating', reviewDetails.client_platform_rating);
    formData.append('client_platform_comment', reviewDetails.client_platform_comment);

    formData.append('project_budget', reviewDetails.project_budget);
    formData.append('project_type', reviewDetails.project_type);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async updateReview(assistantId, projectId, reviewDetails) {
    let url = `${Config.apiHost}/admin/update-review/${projectId}/${assistantId}`;
    let formData = new FormData();

    formData.append('assistant_rating', reviewDetails.assistant_rating);
    formData.append('assistant_comment', reviewDetails.assistant_comment);
    formData.append('assistant_platform_rating', reviewDetails.assistant_platform_rating);
    formData.append('assistant_platform_comment', reviewDetails.assistant_platform_comment);

    formData.append('client_rating', reviewDetails.client_rating);
    formData.append('client_comment', reviewDetails.client_comment);
    formData.append('client_platform_rating', reviewDetails.client_platform_rating);
    formData.append('client_platform_comment', reviewDetails.client_platform_comment);

    formData.append('project_budget', reviewDetails.project_budget);
    formData.append('project_type', reviewDetails.project_type);

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async activateReview(assistantId, projectId) {
    let url = `${Config.apiHost}/admin/activate-review/${projectId}/${assistantId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async inactivateReview(assistantId, projectId) {
    let url = `${Config.apiHost}/admin/inactivate-review/${projectId}/${assistantId}`;
    let formData = new FormData();

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async generatePaymentLink(linkDuration, details) {
    let url = `${Config.apiHost}/admin/generate-payment-link/${linkDuration}`;
    let formData = new FormData();

    if (details) {
      formData.append('details', JSON.stringify(details));
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

  async addAccess(details) {
    let url = `${Config.apiHost}/admin/add-access`;
    let formData = new FormData();

    if (details) {
      formData.append('details', JSON.stringify(details));
    }

    let response = await fetch(url, {
      method: "POST",
      body: formData,
      credentials: "include"
    });

    return await handleResponse(response);
  },

}